import { Component, OnInit, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PartnerService } from '../../../../../services/partner.service';
import { ServiceRequestService } from '../../../../../services/servicerequest.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { RentalsService } from '../../../../../services/rentals.service';

@Component({
  selector: 'app-rentals-products-import',
  templateUrl: './rentals-products-import.component.html',
  styleUrls: ['./rentals-products-import.component.scss'],
})
export class RentalsProductsImportComponent implements OnInit {
  public keys: string[];
  public dataSheet = new Subject();
  public data: any = [];

  public importData: any = [];
  public servicesTypes: any = [];
  public isExcelFile: boolean;

  public hasValidationErrors: boolean = false;
  public invalidFileFormat: boolean = false;

  public importing: boolean = false;
  public progress: number = 0;
  public step = 1;

  @ViewChild('fileUpload') fileUpload: any;
  public columns: any = [
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.categoryname',
      ),
      field: 'CategoryName',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.brand',
      ),
      field: 'Brand',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.model',
      ),
      field: 'Model',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.yearmodel',
      ),
      field: 'YearModel',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.color',
      ),
      field: 'Color',
      type: 'dateSummary',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.pricegroupname',
      ),
      field: 'PriceGroupName',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.size',
      ),
      field: 'Size',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.status',
      ),
      field: 'Status',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.validationstatus',
      ),
      field: 'ValidationStatus',
      type: 'status',
    },
  ];

  public columnsImported: any = [
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.categoryname',
      ),
      field: 'CategoryName',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.brand',
      ),
      field: 'Brand',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.model',
      ),
      field: 'Model',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.yearmodel',
      ),
      field: 'YearModel',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.color',
      ),
      field: 'Color',
      type: 'dateSummary',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.pricegroupname',
      ),
      field: 'PriceGroupName',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.size',
      ),
      field: 'Size',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.status',
      ),
      field: 'Status',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.rental_products_imports.headers.importstatus',
      ),
      field: 'ImportStatus',
      type: 'status',
    },
  ];

  constructor(
    public router: Router,
    private translate: TranslateService,
    private helpersService: HelpersService,
    private rentalsService: RentalsService,
  ) {}

  ngOnInit() {}

  prepareFile(evt) {
    let data, header;

    const target: DataTransfer = <DataTransfer>evt.target;
    this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      data = XLSX.utils.sheet_to_json(ws, { raw: false, defval: null });
    };

    reader.readAsBinaryString(target.files[0]);

    reader.onloadend = (e) => {
      this.keys = Object.keys(data[0]);
      this.dataSheet.next(data);
      /*this.dataSheet.subscribe(sheetData=>{
                    this.processFile(sheetData);
                  });*/
      this.processFile(data);
    };
    this.fileUpload.nativeElement.value = '';
  }

  processFile(data) {
    this.invalidFileFormat = false;
    this.hasValidationErrors = false;

    console.log(this.keys);
    console.log(data);

    if (
      this.keys.indexOf('Category Name') > -1 &&
      this.keys.indexOf('Brand') > -1 &&
      this.keys.indexOf('Model') > -1 &&
      this.keys.indexOf('Year Model') > -1 &&
      this.keys.indexOf('Price Group Name') > -1 &&
      this.keys.indexOf('Size') > -1 &&
      this.keys.indexOf('Status') > -1
    ) {
      this.step = 2;
      this.processHubtigerTemplate(data);
    } else {
      this.invalidFileFormat = true;
    }
  }

  processHubtigerTemplate(data) {
    var sheetData = [];
    data.slice(1).forEach((row) => {
      var validation = this.validateRow(row);
      var valid = validation === 'Valid';

      sheetData.push({
        CategoryName: row['Category Name'] || null,
        Brand: row['Brand'] || null,
        Model: row['Model'] || null,
        YearModel: row['Year Model'] || null,
        Color: row['Color'] || null,
        PriceGroupName: row['Price Group Name'] || null,
        Size: row['Size'] || null,
        SizeDescription: row['Size Description'] || null,
        InitialProductValue: row['Initial Product Value'] || null,
        ProductDescription: row['ProductDescription'] || null,
        SerialNumber: row['Serial Number'] || null,
        Status: row['Status'] || null,
        ImageUrl: row['ImageUrl'] || null,
        ValidationStatus: validation,
      });
      if (!valid) {
        this.hasValidationErrors = true;
      }
    });

    this.data = sheetData;
  }

  validateRow(row) {
    var message = '';
    if (
      row['Category Name'] === null ||
      row['Category Name'] === undefined ||
      row['Category Name'].length === 0
    ) {
      message +=
        '<li>' +
        this.translate.instant(
          'bikeshop.rental_products_imports.errors.no_categoryname',
        ) +
        '</li>';
    }
    if (
      row['Brand'] === null ||
      row['Brand'] === undefined ||
      row['Brand'].length === 0
    ) {
      message +=
        '<li>' +
        this.translate.instant(
          'bikeshop.rental_products_imports.errors.no_brand',
        ) +
        '</li>';
    }
    if (
      row['Model'] === null ||
      row['Model'] === undefined ||
      row['Model'].length === 0
    ) {
      message +=
        '<li>' +
        this.translate.instant(
          'bikeshop.rental_products_imports.errors.no_model',
        ) +
        '</li>';
    }
    if (
      row['Year Model'] === null ||
      row['Year Model'] === undefined ||
      row['Year Model'].length === 0
    ) {
      message +=
        '<li>' +
        this.translate.instant(
          'bikeshop.rental_products_imports.errors.no_yearmodel',
        ) +
        '</li>';
    }
    if (
      row['Price Group Name'] === null ||
      row['Price Group Name'] === undefined ||
      row['Price Group Name'].length === 0
    ) {
      message +=
        '<li>' +
        this.translate.instant(
          'bikeshop.rental_products_imports.errors.no_pricegroupname',
        ) +
        '</li>';
    }
    // if(row['Size'] === null || row['Size'] === undefined || row['Size'].length === 0){
    //   message += "<li>" + this.translate.instant('bikeshop.rental_products_imports.errors.no_size') + "</li>";
    // }
    // if (!(['12"', '16"', '20"', '26"', 'XS', 'S', 'M', 'M/L', 'L', 'XL', 'XXL'].includes(row['Size']))) {
    //   message += "<li>" + this.translate.instant('bikeshop.rental_products_imports.errors.no_validsize') + "</li>";
    //   //"bikeshop.rental_products_imports.errors.no_validsize": "Select a valid size from the list of: 12\", 16\", 20\", 24\", 26\", XS, S, M, M/L, L, XL, XXL",
    // }
    // if(row['Status'] === null || row['Status'] === undefined || row['Status'].length === 0){
    //   message += "<li>" + this.translate.instant('bikeshop.rental_products_imports.errors.no_status') + "</li>";
    // }

    return message === '' ? 'Valid' : message;
  }

  resetWizard() {
    this.invalidFileFormat = false;
    this.hasValidationErrors = false;
    this.keys = [];
    this.data = [];
    this.step = 1;
  }

  downloadTemplate() {
    window.open('/assets/excel-tempates/Rental Product Import Template.xlsx');
  }

  beginImport() {
    this.importData = [];
    this.progress = 0;
    console.log('before');
    console.log(this.data);

    this.importData = this.data
      .filter((x) => x.ValidationStatus === 'Valid')
      .map((data, index) => ({
        ...data,
        Index: index + 1,
        ImportStatus: null,
      }));

    console.log('after');
    console.log(this.importData);

    if (this.importData.length <= 0) {
      alert(
        this.translate.instant(
          'bikeshop.rental_products_imports.errors.no_valid_rows_to_import',
        ),
      );
      return;
    }

    this.step = 3;
    this.importing = true;

    this.pushDataToHubtiger();
  }

  pushDataToHubtiger() {
    var data = {
      Items: this.importData.filter((x) => {
        return x.ImportStatus === null;
      }),
    };

    this.rentalsService
      .importRentalProducts(this.helpersService.getPartnerId(), data)
      .subscribe(
        (imported) => {
          console.log(imported);
          imported.forEach((item) => {
            var found = this.importData
              .filter((x) => x.Index === item.Index)
              .pop();
            if (found !== null && found !== undefined) {
              found.ImportStatus = item.ImportStatus;
            }
          });

          this.progress = Math.round(
            (this.importData.filter((x) => {
              return x.ImportStatus !== null;
            }).length /
              this.importData.length) *
              100,
          );

          if (
            this.importData.filter((x) => {
              return x.ImportStatus === null;
            }).length > 0
          ) {
            this.pushDataToHubtiger();
          } else {
            this.importing = false;
            alert(
              this.translate.instant(
                'bikeshop.rental_products_imports.feedback.complete',
              ),
            );
            console.log('Completed');
          }
        },
        (err) => {
          this.step = 2;
          this.importing = false;
          alert(
            this.translate.instant(
              'bikeshop.rental_products_imports.errors.failed_to_import',
            ),
          );
        },
      );
  }

  backToProducts() {
    this.router.navigate(['/store/rentals/products-accessories']);
  }
}
